import React from 'react';
import styled, { css } from 'styled-components';
import { theme } from '../../../theme';
import { UIText } from '../../typography';
import { Alignment } from '../../../types';

export type SimpleTableProps = StyledSimpleTableProps & {
  headerChildren?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
};

type StyledSimpleTableProps = {
  columns?: number;
  hideBottomBorder?: boolean;
  removeRowGap?: boolean;
};

type CellProps = {
  align?: Alignment;
};

const StyledSimpleTable = styled.div<StyledSimpleTableProps>`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
  ${({ hideBottomBorder }) =>
    !hideBottomBorder &&
    css`
      padding-bottom: 1px;
    `};
  width: 100%;
  row-gap: ${({ removeRowGap }) => (removeRowGap ? '0' : '1px')};
  background-color: ${theme.colors.neutrals.solidGrays[6]};
`;

export const SimpleTableHead = styled.div`
  padding: ${theme.spacings[3].rem} 0;
`;

export const SimpleTableLabel = styled(UIText)<CellProps>`
  background-color: ${theme.colors.primary.white};
  font-weight: 700;
  text-align: ${({ align }) => align};
`;

export const SimpleTableCell = styled.div<CellProps>`
  background-color: ${theme.colors.primary.white};
  padding: ${theme.spacings[3].rem} 0;
  text-align: ${({ align }) => align};
  justify-content: center;
  vertical-align: top;
`;

export const SimpleTable: React.FC<SimpleTableProps> = ({
  headerChildren,
  children,
  columns = 2,
  hideBottomBorder = false,
  removeRowGap = false,
  className,
}) => {
  return (
    <StyledSimpleTable
      columns={columns}
      hideBottomBorder={hideBottomBorder}
      removeRowGap={removeRowGap}
      className={className}
    >
      {headerChildren}
      {children}
    </StyledSimpleTable>
  );
};
